import format from '@/module/util/format'

const COLOR =  [ 'gray', 'brown', 'yellow', 'red', 'dark green', 'dark brown', 'black' ]
const COLOR_CODE = [ '#D8D8D8', '#DFA049', '#F5D90C', '#FF5454', '#598542', '#7D541B', '#424242' ]
const TEXT_COLOR_CODE = ['black', 'black', 'black', 'white', 'white', 'white', 'white']
const VOLUME = [ 'small', 'medium', 'large' ]
// Bitmask
const EXPERIENCE = [ 'strong urge', 'incontinence', 'didn\'t empty', 'staining', 'straining' ]

export default {
	props: {
		excretion: {
			type: Array,
			required: true
		}
	},

	methods: {
		...format,
		binWidth(bin, total) {
			if (total == 0) return 0
			return (bin * 100.0 / total) + '%'
		},
		binLabel(bin, total) {
			if (total == 0) return 0
			return Math.round(bin * 100.0 / total) + '%'
		},
		getExperience(experience) {
			let mask = []
			EXPERIENCE.forEach((bit, i) => {
				if (experience & (1 << i)) {
					mask.push(bit)
				}
			})
			return mask
		},
		formImage(form) {
			return require('./image/form/' + form + '.png')
		},
		formatForm(form) {
			return 'Form ' + form
		},
		formatColor(color) {
			return COLOR[color]
		},
		colorCode(color) {
			return COLOR_CODE[color]
		},
		textColorCode(color) {
			return TEXT_COLOR_CODE[color]
		},
		formatVolume(volume) {
			return VOLUME[volume]
		}
	},

	computed: {
		sortedExcretion() {
			return this.excretion.slice().sort((a, b) => (b.time - a.time))
		},
		formBins() {
			var bins = [0, 0, 0, 0, 0, 0, 0]
			this.excretion.forEach((excretion) => {
				if (excretion.form != null)
					bins[excretion.form - 1]++
			})
			return bins
		},
		colorBins() {
			var bins = COLOR.map(() => 0)

			this.excretion.forEach((excretion) => {
				if (excretion.color != null)
					bins[excretion.color]++
			})
			return bins
		},
        volumeBins() {
			var bins = VOLUME.map(() => 0)

			this.excretion.forEach((excretion) => {
				if (excretion.volume != null)
					bins[excretion.volume]++
			})
			return bins
		},
		formTotal() {
			return this.formBins.reduce((a, b) => (a + b), 0)
		},
		colorTotal() {
			return this.colorBins.reduce((a, b) => (a + b), 0)
		},
        volumeTotal() {
            return this.volumeBins.reduce((a, b) => (a + b), 0)
        }
	}
}
